export default "__VITE_ASSET__ddcf4a60__"